
<nav *ngIf="!isHighlights" class="back-to-website-link-component">
  <a class="text-uppercase back-to-website-link" [href]="linkUrl">
    {{linkText}}
  </a>
</nav>